const getAriaLabel = ({ ariaLabel, animation }) => ariaLabel
    ? ariaLabel
    : animation === 'error'
        ? 'Error'
        : animation === 'progress' || animation === 'success'
            ? undefined
            : 'IconButton';
export default getAriaLabel;
